var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuraSuite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52326_453791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.58 0H6.41996C2.87431 0 0 2.87431 0 6.41996V25.58C0 29.1257 2.87431 32 6.41996 32H25.58C29.1257 32 32 29.1257 32 25.58V6.41996C32 2.87431 29.1257 0 25.58 0Z",
    fill: "url(#paint0_linear_52326_453791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41009 24.0627C9.16486 24.0627 8.92133 23.9697 8.7336 23.7819C6.74131 21.7897 5.67245 19.1395 5.72657 16.3202C5.78069 13.5026 6.95103 10.8947 9.02111 8.97342C12.933 5.3474 19.0637 5.3474 22.9756 8.97342C25.0473 10.893 26.2177 13.5026 26.2701 16.3185C26.3242 19.1378 25.2553 21.7863 23.2631 23.7803C22.8893 24.154 22.2838 24.154 21.9118 23.7803C21.5397 23.4065 21.538 22.801 21.9118 22.4289C23.5337 20.807 24.403 18.6507 24.359 16.3557C24.315 14.0624 23.3628 11.9399 21.675 10.3755C18.4921 7.42425 13.5029 7.42425 10.32 10.3755C8.63381 11.9382 7.67995 14.0624 7.63598 16.3557C7.59201 18.6507 8.46131 20.807 10.0832 22.4289C10.457 22.8027 10.457 23.4082 10.0832 23.7803C9.89717 23.9663 9.65194 24.061 9.40671 24.061L9.41009 24.0627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0371 17.7041H9.96336C9.4357 17.7041 9.00781 17.2762 9.00781 16.7485C9.00781 16.2209 9.4357 15.793 9.96336 15.793H22.0355C22.5631 15.793 22.991 16.2209 22.991 16.7485C22.991 17.2762 22.5631 17.7041 22.0355 17.7041H22.0371Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52326_453791",
    x1: 0,
    y1: 0,
    x2: 38.5269,
    y2: 13.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121865",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121865"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52326_453791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuraSuite);
export default __webpack_public_path__ + "static/media/aura_suite.65ca9bf9a4b7c6670d4481435ec32aaf.svg";
export { ForwardRef as ReactComponent };